/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { hdprojectproductInfo, getHdProjectBom, getHdProjectProductInfo, postHdHdprojectproductUpdateScrapDestination } from '@/api';
import Tabbar from "vux/src/components/tabbar/tabbar.vue";
import TabbarItem from "vux/src/components/tabbar/tabbar-item.vue";
import Cell from "vux/src/components/cell/index.vue";
import Confirm from "vux/src/components/confirm/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import XTextarea from "vux/src/components/x-textarea/index.vue";
var jsonMap = {
  out_date: '制造日期',
  product_model: '型号',
  rated_current: '额定电流',
  rated_rate: '额定频率',
  rated_voltage: '额定电压',
  serial_number: '出厂编号',
  technical: '执行标准',
  state: '状态',
  rated_withstand_voltage: '额定工频电压',
  thunder_voltage: '额定雷电冲击',
  rated_break_current: '额定短路开断电流',
  rated_time: '额定短路持续时间',
  tw_current: '额定峰值耐受电流',
  rated_short_current: '额定断时耐受电流',
  dc_component: '直流',
  level: '分类等级',
  operation_seq: '额定操作顺序',
  auxiliary_voltage: '辅助电压',
  weight: '重量'
};
var standMap = ['serial_number', 'product_model', 'rated_voltage', 'rated_current', 'rated_rate', 'technical', 'out_date'];
var standMapUp = standMap.map(function (v) {
  return v.toUpperCase();
});
export default {
  name: 'Info',
  components: {
    Tabbar: Tabbar,
    TabbarItem: TabbarItem,
    Cell: Cell,
    Confirm: Confirm,
    XTextarea: XTextarea
  },
  directives: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      isShowExamineModal: false,
      examineReason: '',
      standMapUp: standMapUp,
      standMap: standMap,
      jsonMap: jsonMap,
      info: {},
      bomList: [],
      showIndex: 0,
      productInfo: []
    };
  },
  created: function created() {
    this.getProductInfo();
    this.getInfo();
    this.getBom();
  },
  methods: {
    examineOperation: function examineOperation(value) {
      var _this = this;

      var data = {
        id: this.info.production_id,
        destination: value
      };
      this.isShowExamineModal = false;
      postHdHdprojectproductUpdateScrapDestination(data).then(function (res) {
        if (res.data.code === 0) {
          _this.getInfo();

          _this.$vux.toast.text('保存成功');
        } else {
          _this.$vux.toast.text(res.msg);
        }
      });
    },
    handleEdit: function handleEdit() {
      this.examineReason = this.info.scrap_destination || '';
      this.isShowExamineModal = true;
    },
    jsonMapFunc: function jsonMapFunc(key) {
      var lowerKey = key.toLowerCase();
      return this.jsonMap[lowerKey] || '参数';
    },
    getProductInfo: function getProductInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var code, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                code = new URLSearchParams(location.search).get('code') || '';

                if (code) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return getHdProjectProductInfo({
                  code: code
                });

              case 5:
                res = _context.sent;

                if (res.data.code === 0) {
                  _this2.productInfo = res.data.hdProfile;
                } else {
                  _this2.$vux.toast.text(res.message);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getInfo: function getInfo() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 首页获取的id，localStorage不能立即拿到，需要延时获取
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (localStorage.getItem('id')) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          _context2.next = 4;
                          return hdprojectproductInfo(localStorage.getItem('id'));

                        case 4:
                          res = _context2.sent;

                          if (res.data.code === 0) {
                            _this3.info = res.data.hdProjectProduct;
                          } else {
                            _this3.$vux.toast.text(res.message);
                          }

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), 500);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getBom: function getBom() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var code, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                code = new URLSearchParams(location.search).get('code') || '';

                if (code) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return getHdProjectBom({
                  code: code
                });

              case 5:
                res = _context4.sent;

                if (res.data.code === 0) {
                  _this4.bomList = res.data.hdProjectProduct || [];
                } else {
                  _this4.$vux.toast.text(res.message);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleShow: function handleShow(index) {
      this.showIndex = index;
    }
  }
};